import { Components } from 'components/Reporting/Overview/FilterBuilder/Filters'
import { ifAutofocusedItem } from 'components/Reporting/Overview/FilterBuilder/Filters/Constants'
import { demographicList } from 'components/Reporting/Overview/FilterBuilder/FilterSet/Constants'
import { isActiveQuestions } from 'components/Participants/Filters/SignUpQuestions/ActiveDemographic'
import { isAuthorized } from 'lib/authorization/AuthorizeComponent'
import { FilterItem, SavedFilter } from 'types/FilterBuilder'

export const filterWithComponent = (
  filterProps: FilterItem,
  index: number,
  savedSelectionFilters?: FilterItem[],
  savedFilter?: SavedFilter,
) => {
  const { component } = filterProps

  const Filter = Components[component]
  let isAutoFocusEnabled = false
  if (savedSelectionFilters?.length) {
    isAutoFocusEnabled = ifAutofocusedItem(
      savedSelectionFilters,
      filterProps.name,
    )
      ? false
      : true
  } else if (savedFilter?.filterName === '') {
    isAutoFocusEnabled = true
  }

  return (
    Filter && (
      <Filter
        type={filterProps.name}
        item={filterProps}
        index={index}
        isAutoFocusEnabled={isAutoFocusEnabled}
      />
    )
  )
}

export const toggleFeature = (
  filter: FilterItem,
  featureToggle: boolean,
  filterText: string,
) => {
  if (!featureToggle) {
    return filter?.name !== filterText
  }
  return filter
}

export const getDemographicOutput = async () => {
  const result = await isActiveQuestions(demographicList)
  return result
}

export const filterListAllowed = (LIST_FILTERS_APPLIED: FilterItem[]) => {
  const showProjectFilters = isAuthorized('enable_reporting_filter_builder')
  const showParticipantPageHubFilters = isAuthorized(
    'enable_participant_page_hub_filters',
  )

  const PROJECTS_FILTER_LIST = LIST_FILTERS_APPLIED.filter(
    (filter: FilterItem) => filter.category === 'project',
  )
  const filtersList =
    showProjectFilters && showParticipantPageHubFilters
      ? LIST_FILTERS_APPLIED
      : PROJECTS_FILTER_LIST
  return filtersList
}

export const defaultFilterset = (
  FILTER_LIST: FilterItem[],
  allowedFilterList: FilterItem[],
) => {
  return FILTER_LIST.filter(
    (filter: FilterItem) =>
      filter.isSelected &&
      (filter.name == 'dateRange' || allowedFilterList.includes(filter)),
  ).map((filter: FilterItem) => {
    return { ...filter, defaultOpen: false }
  })
}
